import React__default from 'react';
import classNames from './../external_lib/classnames/index.js';
import Typography from '../Atoms/Typography.js';
import Button from '../Atoms/Button.js';
import { useTranslation } from 'react-i18next';
import LazyImage from '../Atoms/LazyImage.js';

function WhyChooseUsSectionTwo(_a) {
    var classes = _a.classes, onReadMore = _a.onReadMore, desc = _a.desc, _b = _a.values, values = _b === void 0 ? [] : _b, title = _a.title, imageComponent = _a.imageComponent;
    var t = useTranslation().t;
    return (React__default.createElement("div", { className: classNames('why-choose-us-section-two', classes) },
        React__default.createElement("div", { className: "why-choose-us-section__left" }, values.map(function (value) {
            return (React__default.createElement("div", { title: value.description, className: "reason-card__container" },
                React__default.createElement(LazyImage, { classes: "reason-card__icon", src: value.icon, alt: value.label, imageComponent: imageComponent }),
                React__default.createElement(Typography, { variant: "bodyTextOne", classes: "reason-card__title" }, value.label),
                React__default.createElement(Typography, { variant: "bodyTextOne", classes: "reason-card__msg" }, value.description)));
        })),
        React__default.createElement("div", { className: "why-choose-us-section__right" },
            React__default.createElement(Typography, { classes: "why-choose-us-section-two__title", variant: "displayText", weight: "bold" }, title ? title : t('landingScreen.whyChooseUs')),
            React__default.createElement(Typography, { classes: "why-choose-us-section-two__description", variant: "bodyTextOne" }, desc),
            React__default.createElement(Button, { variant: "solid", classes: "why-choose-us-section-two__cta", onClick: onReadMore, size: "md" }, t('landingScreen.readMore')))));
}

export { WhyChooseUsSectionTwo as default };
//# sourceMappingURL=WhyChooseUsSectionTwo.js.map
